<div class="reports-no-discounts">
  <div class="">
    <div class="empty-discounts-note">
      <i class="mdi mdi-lock" style="font-size: 50px;"></i>
      <div class="mt-3"></div>
      <div>You are not authorized to perform this operation</div>
    </div>
    <div class="mt-3"></div>
    <div class="">
        <a><button
          class="rounded-pill btn btn-dark f-14 fw-700"
          (click)="redirectTo()">
          Back
        </button></a>
    </div>
  </div>

</div>
